import { render, staticRenderFns } from "./WaterFee.vue?vue&type=template&id=2307e8d8&scoped=true&"
import script from "./WaterFee.vue?vue&type=script&lang=js&"
export * from "./WaterFee.vue?vue&type=script&lang=js&"
import style0 from "./WaterFee.vue?vue&type=style&index=0&id=2307e8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307e8d8",
  null
  
)

export default component.exports